import request from '@/utils/request'

// 查询企业工作室-申报事项信息
export function listSbsxcx(query) {
  return request({
    url: '/web/qydjxx/sbsxcx/list',
    method: 'get',
    params: query
  })
}
